var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-verify-account-widget',{on:{"verified":_vm.goHome,"cancel":_vm.goLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }